import { Button, ButtonGroup, Center, Heading, VStack } from '@masterplandev/ui'

import useTranslation from '@/core/hooks/useTranslation'

type PollFormErrorProps = {
  onClose: () => void
  onRetry: () => void
}

export function PollFormError({ onClose, onRetry }: PollFormErrorProps) {
  const { translate } = useTranslation('poll-form-error')

  return (
    <Center w="full">
      <VStack gap="6">
        <Heading as="h4" size={['h5', 'h4']}>
          {translate('title')}
        </Heading>
        <ButtonGroup gap="4">
          <Button variant="outline" onClick={onClose}>
            {translate('close')}
          </Button>
          <Button
            onClick={() => {
              onRetry()
            }}>
            {translate('retry')}
          </Button>
        </ButtonGroup>
      </VStack>
    </Center>
  )
}
